import axios from "axios";

export default async function fetchWalletSetting() {
  const url = `${
    process.env.NEXT_PUBLIC_WALLET_SETTING_CDN
  }?q=${new Date().getTime()}`;
  let result = null;
  const res = await axios({
    method: "get",
    url: url,
  });
  if (res.status === 200) {
    result = res.data;
    console.log("🚀 ~ fetchWalletSetting ~ result:", result);
  }
  return result;
}
